import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideCac } from './cac.config';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DateInterceptor } from './core/interceptors';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(appRoutes), provideCac(),
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DateInterceptor,
    multi: true
  }],
};
